'use client';
import React, { createContext, useContext, ReactNode, useState } from 'react';

type DisclaimerToggleContextType = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

const DisclaimerToggleContext = createContext<
  DisclaimerToggleContextType | undefined
>(undefined);

export const DisclaimerToggleProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <DisclaimerToggleContext.Provider value={{ open, setOpen }}>
      {children}
    </DisclaimerToggleContext.Provider>
  );
};

// Hook to use the locale context
export const useDisclaimerToggle = (): DisclaimerToggleContextType => {
  const context = useContext(DisclaimerToggleContext);
  if (!context) {
    throw new Error(
      'useDisclaimerToggle must be used within a DisclaimerToggleProvider'
    );
  }
  return context;
};
